import React, { useState, useEffect } from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import LoginForm from "../../components/Login/LoginForm";
import LayoutOut from "../../components/Layout/LayoutOut";
import logo from '../../assets/images/elanciaatwork.png';
import TitleMain from "../../components/Title/TitleMain";
import styles from '../../components/Layout/LayoutOut.module.css';
import {getUser, login} from '../../services/AuthService';
import {useUser} from "../../contexts/UserContext";
import {useModal} from "../../contexts/ModalContext";

function LoginPage() {
    const [showSplash, setShowSplash] = useState(false);
    const [splashTitle, setSplashTitle] = useState("Bienvenue !");
    const { user, setUser, loading } = useUser();
    const navigate = useNavigate();
    const location = useLocation();
    const email = location.state?.email;
    const { showModal, hideModal } = useModal();

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 3000});
    };

    useEffect(() => {
        if (user) {
            setShowSplash(true);
        }
    }, [user]);

    useEffect(() => {
        if (!loading && user) {
            // navigate('/accueil');
            setShowSplash(true);
        }
    }, [user, loading, navigate]);

    useEffect(() => {
        if (!user) return ;
        let timer;
        if (showSplash) {
            timer = setTimeout(() => {
                navigate('/');
            }, process.env.REACT_APP_SHOW_SPLASHSCREEN_DELAY);
        }
        return () => clearTimeout(timer);
    }, [showSplash, navigate]);

    const handleSubmit = async (values) => {
        try {
            let missingFields = [];
            let invalidFields = [];

            if (!values.email) {
                missingFields.push('identifiant');
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
                invalidFields.push('identifiant');
            }
            if (!values.password) {
                missingFields.push('mot de passe');
            }
            if (missingFields.length > 0) {
                handleError('Merci de renseigner votre ' + missingFields.join(' et votre '));
                return ;
            }
            if (invalidFields.length > 0) {
                handleError('Le format de votre ' + invalidFields.join(' et votre ') + ' ne correspond pas à un courriel.');
                return;
            }

            const rez = await login(values);
            if (!rez.success) {
                if (rez.message) {
                    handleError(rez.message);
                } else if (rez.error) {
                    handleError(rez.error);
                }
                return rez;
            }

            const user = await getUser();
            if (!user){
                handleError("Erreur lors de la récupération de l'utilisateur");
                return;
            }

            setUser(user);

            setShowSplash(true);
        } catch (error) {
            alert(error.message);
        }
    };

    return (
        <LayoutOut>
            {showSplash ? (
                <div className={styles.splashScreen}>
                    <TitleMain text={splashTitle} />
                    <img src={user && user.entreprise ? user.entreprise.logo : logo} alt="Logo de l'entreprise" />
                </div>
            ) : (
                <>
                    <img className={styles.logo} alt="elancia" src={user && user.entreprise ? user.entreprise.logo : logo}/>

                    <LoginForm handleSubmit={handleSubmit} email={email}/>
                </>
            )}
        </LayoutOut>
    );
}

export default LoginPage;

